import React, { useState } from "react";

import { StepContextWrapper } from "./StepContext";
import { AnswersContextWrapper } from "./AnswersContext";
import { QuestionsContextWrapper } from "./QuestionsContext";

export const ContextWrapper = (props) => {
    return (
        <StepContextWrapper>
            <QuestionsContextWrapper>
                <AnswersContextWrapper>{props.children}</AnswersContextWrapper>
            </QuestionsContextWrapper>
        </StepContextWrapper>
    );
};
